var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.logading)?_c('div',[_c('quill-editor',{ref:_vm.refName,class:`editor ` + _vm.refName,attrs:{"options":_vm.editorOption},on:{"change":_vm.dataOut},model:{value:(_vm.dataModel),callback:function ($$v) {_vm.dataModel=$$v},expression:"dataModel"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }